import moment, { MomentInput } from "moment-timezone";
import {
  DEFAULT_ENDS_AFTER_SESSIONS,
  REPEAT_END_TYPE_OPTIONS,
} from "../session-repeat-rule-editor-constants";

/**
 * get repeat end field value by repeat end type
 */
export function getRepeatEndByType({
  type,
  timezone,
  repeat_every,
  repeat_interval,
  intervalStart,
}: {
  type: RepeatRule["repeat_end"]["type"];
  timezone: string;
  repeat_every: RepeatRule["repeat_every"];
  repeat_interval: RepeatRule["repeat_interval"];
  intervalStart: MomentInput;
}): RepeatRule["repeat_end"] {
  if (type === REPEAT_END_TYPE_OPTIONS.end_after.id) {
    return {
      type,
      end_after: DEFAULT_ENDS_AFTER_SESSIONS,
    };
  }

  return {
    type: REPEAT_END_TYPE_OPTIONS.end_date.id,
    end_date: moment(intervalStart)
      .tz(timezone)
      .add(repeat_every, repeat_interval)
      .add(1, "day")
      .startOf("day")
      .toISOString(),
  };
}
